import { SET_PAGE_NOT_FOUND } from '@actions/pageNotFoundActions'

interface PageNotFoundAction {
  type: string
  payload: {
    show: boolean
  }
}

const initialState = {
  show: false,
}

export default function pageNotFoundReducer(state = initialState, action: PageNotFoundAction) {
  if (action.type === SET_PAGE_NOT_FOUND) {
    return {
      ...state,
      show: action.payload.show,
    }
  } else {
    return state
  }
}
